import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import {
  FaHome, FaUserGraduate, FaMoneyCheckAlt, FaBus, FaClipboardList,
  FaChartBar, FaFileAlt, FaArrowCircleRight, FaFlask,
  FaDatabase,
  FaMask,
  FaGooglePay,FaUsers,FaPaperPlane,FaSms
} from 'react-icons/fa';

import StudentDetails from './studentdetails';
import Dashboard from './dashboard';
import SalesTable from './tableformat';
import StudentDetails1 from './TestEntry';
import FeesEntry from './FeesEntry';
import NewStudentList from './newstudentlist';
import BusFeesEntry from './BusFeesEntry';
import PendingFeesList from './PendingFeesList';
import OverAllStudentList from './OverAllStudentList';
import NaviTest from './NavicatTest';
import StudentPromotionList from './StudentPromotion';
import CollectionReport from './Reports/CollectionReport';
import PendingStudentList from './PendingStudent';
import StudentPendingReport from './Reports/StudentPendingReport';
import TransportPendingReport from './Reports/TransportPendingReport';
import CustomTable from './CustomizeTable';
import FeesCollection from './Fees/FeesCollection';
import StudentFeesCollection from './Fees/StudentFeesCollection';
import PaymodeMast from '../Master/PaymodeMast';
import { useAuth } from './LogIn/AuthContext';
import ExportCollectionReport from './Fees/ExportTest';
import AllReports from './Reports/AllReports';
import BonafideList from './BonafideCertificate/BonafideList';
import StaffMast from '../Master/StaffMast';
import SumOfReports from './Reports/SumOfReport';
import StudentSmsList from './SMS/SentSms';
import UserMast from '../Master/UserMast';
import FeesAddMaster from './Fees/FeesMaster';

const Breadcrumb = ({user}) => {
   
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  const routeNameMap = {
    StudentDetails: 'Student Details',
    NewStudentList: 'Admission Fees',
    StudentDetails1: 'Test Entry',
    BusFeesEntry: 'Bus Fees Entry',
    PendingFeesList: 'Pending Entry',
    OverAllStudentList: 'Overall Student List',
    SalesTable: 'Sales Table',
    FeesEntry: 'Fees Entry',
    NaviTest: 'Test Entry',
    StudentPromotionList: 'Student Promotion',
    CollectionReport: 'Collection Report',
    PendingStudentList: 'Pending Students',
    StudentPendingReport: 'Fees Pending Report',
    TransportPendingReport: 'Transport Pending Report',
    CustomTable: 'Customize Table',
  };

  

  return (
    
    <div style={breadcrumbStyles.container}>
      <Link to="/" style={breadcrumbStyles.link}>Home</Link>
      {pathnames.map((value, index) => {
        const to = '/' + pathnames.slice(0, index + 1).join('/');
        const label = routeNameMap[value] || value.replace(/([A-Z])/g, ' $1').replace(/\b\w/g, (c) => c.toUpperCase());
        return (
          <span key={to}>
            {' > '}
            <Link to={to} style={breadcrumbStyles.link}>{label}</Link>
          </span>
        );
      })}
    </div>
  );
};

const breadcrumbStyles = {
  container: {
    padding: '10px 10px',
    fontSize: '12px',
  },
  link: {
    color: '#0074b8',
    textDecoration: 'none',
  },
};


const selectedDB = localStorage.getItem('selectedDB');

function SideNavApp1() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [hovered, setHovered] = useState(false);
  const [openMenu, setOpenMenu] = useState(null); // Only one submenu open at a time
  const { user } = useAuth();
 const [currentTime, setCurrentTime] = useState(new Date().toLocaleTimeString());
  const [currentDate, setCurrentDate] = useState('');
  useEffect(() => {
    const updateDateTime = () => {
      const now = new Date();

      // Format time with AM/PM
      const timeString = now.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
      });

      // Format date: dd/MMM/yyyy
        const day = String(now.getDate()).padStart(2, '0');
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const month = monthNames[now.getMonth()];
      const year = now.getFullYear();
      const dateString = `${day}/${month}/${year}`;

      setCurrentTime(timeString);
      setCurrentDate(dateString);
    };

    updateDateTime(); // initial call
    const interval = setInterval(updateDateTime, 1000);

    return () => clearInterval(interval);
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleMenu = (menuName) => {
    setOpenMenu(prev => (prev === menuName ? null : menuName));
  };

  const handleNavClick = () => {
    // if (isMobile) setHovered(false);
     if (isMobile) {
    setHovered(false);

    // Optional: force reflow to recalculate layout if needed
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 300); // match your transition time
  }

    setOpenMenu(null);
  };

  const collapsedWidth = '60px';
  const expandedWidth = isMobile ? '200px' : '220px';
  const sidebarWidth = hovered ? expandedWidth : collapsedWidth;

  return (
    <div style={styles.appContainer}>
      <div style={styles.banner}>
         <div style={styles.bannerText}>SCISM Matriculation Higher Secondary School</div>
  <div style={styles.userName}>User Name : {user?.name}<br></br>{currentTime}<br></br>{currentDate}<br></br>Yr :{selectedDB}</div>
      </div>

      <div style={styles.bodyContainer}>
        <div
          style={{
            ...styles.sidebar,
            width: sidebarWidth,
            position: isMobile ? 'fixed' : 'relative',
            overflowX: 'hidden',
          }}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
          <nav>
            <ul style={styles.navList}>

              <li style={styles.navItem}>
                <div
                  style={{ ...styles.navLink, cursor: 'pointer' }}
                  onClick={() => toggleMenu('home')}
                  title={!hovered ? 'Home' : ''}
                >
                  <FaHome style={styles.icon} />
                  {hovered && 'Home'}
                </div>
                {openMenu === 'home' && hovered && (
                  <ul style={styles.subMenu}>
                    <li style={styles.navItem}>
                      <Link to="/Dashboard" style={styles.subNavLink} onClick={handleNavClick}>
                        <FaDatabase style={styles.icon} /> Dashboard
                      </Link>
                    </li>
                  </ul>
                )}
              </li>

              <li style={styles.navItem}>
                <div
                  style={{ ...styles.navLink, cursor: 'pointer' }}
                  onClick={() => toggleMenu('student')}
                  title={!hovered ? 'Student Details' : ''}
                >
                  <FaUserGraduate style={styles.icon} />
                  {hovered && 'Student Details'}
                </div>
                {openMenu === 'student' && hovered && (
                  <ul style={styles.subMenu}>
                    <li style={styles.navItem}>
                      <Link to="/StudentDetails" style={styles.subNavLink} onClick={handleNavClick}>
                        <FaUserGraduate style={styles.icon} /> Student Details
                      </Link>
                    </li>
                    <li style={styles.navItem}>
                      <Link to="/NewStudentList" style={styles.subNavLink} onClick={handleNavClick}>
                        <FaMoneyCheckAlt style={styles.icon} /> Admission Fees
                      </Link>
                    </li>
                  </ul>
                )}
              </li>

              <li style={styles.navItem}>
                <div
                  style={{ ...styles.navLink, cursor: 'pointer' }}
                  onClick={() => toggleMenu('fees')}
                  title={!hovered ? 'Fees' : ''}
                >
                  <FaMoneyCheckAlt style={styles.icon} />
                  {hovered && 'Fees'}
                </div>
                {openMenu === 'fees' && hovered && (
                  <ul style={styles.subMenu}>
                    <li style={styles.navItem}>
                      <Link to="/StudentFeesCollection" style={styles.subNavLink} onClick={handleNavClick}>
                        <FaFileAlt style={styles.icon} /> Fees Collection
                      </Link>
                    </li>
                    <li style={styles.navItem}>
                      <Link to="/FeesAddMaster" style={styles.subNavLink} onClick={handleNavClick}>
                        <FaFileAlt style={styles.icon} /> Fees Update
                      </Link>
                    </li>
                    {/* <li style={styles.navItem}>
                      <Link to="/OverAllStudentList" style={styles.subNavLink} onClick={handleNavClick}>
                        <FaClipboardList style={styles.icon} /> Overall Student List
                      </Link>
                    </li>
                    <li style={styles.navItem}>
                      <Link to="/BusFeesEntry" style={styles.subNavLink} onClick={handleNavClick}>
                        <FaBus style={styles.icon} /> Bus Fees Entry
                      </Link>
                    </li> */}
                  </ul>
                )}
              </li>

              <li style={styles.navItem}>
                <div
                  style={{ ...styles.navLink, cursor: 'pointer' }}
                  onClick={() => toggleMenu('promotion')}
                  title={!hovered ? 'Promotion' : ''}
                >
                  <FaArrowCircleRight style={styles.icon} />
                  {hovered && 'Promotion'}
                </div>
                {openMenu === 'promotion' && hovered && (
                  <ul style={styles.subMenu}>
                    <li style={styles.navItem}>
                      <Link to="/StudentPromotionList" style={styles.subNavLink} onClick={handleNavClick}>
                        <FaArrowCircleRight style={styles.icon} /> Student Promotion
                      </Link>
                    </li>
                     <li style={styles.navItem}>
                      <Link to="/StudentSmsList" style={styles.subNavLink} onClick={handleNavClick}>
                        <FaSms style={styles.icon} /> SMS Sent
                      </Link>
                    </li>
                  </ul>
                )}
              </li>

              <li style={styles.navItem}>
                <div
                  style={{ ...styles.navLink, cursor: 'pointer' }}
                  onClick={() => toggleMenu('report')}
                  title={!hovered ? 'Reports' : ''}
                >
                  <FaChartBar style={styles.icon} />
                  {hovered && 'Reports'}
                </div>
                {openMenu === 'report' && hovered && (
                  <ul style={styles.subMenu}>
                    <li style={styles.navItem}>
                      <Link to="/CollectionReport" style={styles.subNavLink} onClick={handleNavClick}>
                        <FaChartBar style={styles.icon} /> Collection Report
                      </Link>
                    </li>
                    <li style={styles.navItem}>
                      <Link to="/StudentPendingReport" style={styles.subNavLink} onClick={handleNavClick}>
                        <FaFileAlt style={styles.icon} /> Fees Pending Report
                      </Link>
                    </li>
                    <li style={styles.navItem}>
                      <Link to="/TransportPendingReport" style={styles.subNavLink} onClick={handleNavClick}>
                        <FaBus style={styles.icon} /> Transport Report
                      </Link>
                    </li>
                      <li style={styles.navItem}>
                      <Link to="/AllReports" style={styles.subNavLink} onClick={handleNavClick}>
                        <FaClipboardList style={styles.icon} />Customized Reports
                      </Link>
                    </li>
                     <li style={styles.navItem}>
                      <Link to="/SumOfReports" style={styles.subNavLink} onClick={handleNavClick}>
                        <FaClipboardList style={styles.icon} />Sum Of Report
                      </Link>
                    </li>
                  </ul>
                )}
              </li>
              <li style={styles.navItem}>
                <div
                  style={{ ...styles.navLink, cursor: 'pointer' }}
                  onClick={() => toggleMenu('master')}
                  title={!hovered ? 'Master' : ''}
                >
                  <FaMask style={styles.icon} />
                  {hovered && 'Master'}
                </div>
                {openMenu === 'master' && hovered && (
                  <ul style={styles.subMenu}>
                     <li style={styles.navItem}>
                      <Link to="/UserMast" style={styles.subNavLink} onClick={handleNavClick}>
                        <FaGooglePay style={styles.icon} /> User Master
                      </Link>
                    </li>
                       <li style={styles.navItem}>
                      <Link to="/StaffMast" style={styles.subNavLink} onClick={handleNavClick}>
                        <FaUsers  style={styles.icon} /> Staff Master
                      </Link>
                    </li>
                    <li style={styles.navItem}>
                      <Link to="/PaymodeMast" style={styles.subNavLink} onClick={handleNavClick}>
                        <FaGooglePay style={styles.icon} /> Paymode Master
                      </Link>
                    </li>
                   {/* <li style={styles.navItem}>
                      <Link to="/ExportCollectionReport" style={styles.subNavLink} onClick={handleNavClick}>
                        <FaGooglePay style={styles.icon} /> Paymode Master
                      </Link>
                    </li> */}
                      <li style={styles.navItem}>
                      <Link to="/BonafideList" style={styles.subNavLink} onClick={handleNavClick}>
                        <FaFileAlt  style={styles.icon} /> Bonafide Certificate
                      </Link>
                    </li>
                  </ul>
                  
                )}
              </li>


           
            </ul>
          </nav>
        </div>

        <div style={{ ...styles.mainContent, marginLeft: isMobile ? sidebarWidth : 0 }}>
          <Breadcrumb />

          <Routes>
            <Route path="/Dashboard" element={<Dashboard user={user} />} />
            <Route path="/StudentDetails" element={<StudentDetails user={user} />} />
            <Route path="/NewStudentList" element={<NewStudentList user={user}/>} />
            <Route path="/PendingFeesList" element={<PendingFeesList user={user}/>} />
            <Route path="/OverAllStudentList" element={<OverAllStudentList user={user}/>} />
            <Route path="/BusFeesEntry" element={<BusFeesEntry user={user}/>} />
            <Route path="/SalesTable" element={<SalesTable user={user}/>} />
            <Route path="/StudentDetails1" element={<StudentDetails1 user={user}/>} />
            <Route path="/FeesEntry" element={<FeesEntry  user={user}/>} />
            <Route path="/NaviTest" element={<NaviTest  user={user}/>} />
            <Route path="/StudentPromotionList" element={<StudentPromotionList user={user}/>} />
            <Route path="/CollectionReport" element={<CollectionReport user={user}/>} />
            <Route path="/PendingStudentList" element={<PendingStudentList user={user}/>} />
            <Route path="/StudentPendingReport" element={<StudentPendingReport user={user}/>} />
            <Route path="/TransportPendingReport" element={<TransportPendingReport user={user}/>} />
            <Route path="/CustomTable" element={<CustomTable user={user}/>} />
            <Route path="/FeesCollection" element={<FeesCollection user={user}/>} />
            <Route path="/StudentFeesCollection" element={<StudentFeesCollection user={user}/>} />
            <Route path="/PaymodeMast" element={<PaymodeMast user={user}/>} />
              <Route path="/ExportCollectionReport" element={<ExportCollectionReport user={user}/>} />
              <Route path="/AllReports" element={<AllReports user={user}/>} />
              <Route path="/BonafideList" element={<BonafideList user={user}/>} />
              <Route path="/StaffMast" element={<StaffMast user={user}/>} />
              <Route path="/SumOfReports" element={<SumOfReports user={user}/>} />
              <Route path="/StudentSmsList" element={<StudentSmsList user={user}/>} />
              <Route path="/UserMast" element={<UserMast user={user}/>} />
                            <Route path="/FeesAddMaster" element={<FeesAddMaster user={user}/>} />
              


              
          </Routes>
        </div>
      </div>
    </div>
  );
}

const styles = {
  appContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    width: '100vw',
    overflow: 'hidden'
  },
  userName:{ marginLeft: 'auto',marginRight:'20px',color:'#464647ff',fontSize:'13px',fontWeight:'bold'},
  banner: {
    height: '80px',
    //backgroundColor: '#a4d4e5',
    background: 'linear-gradient(to right, #F9F4B5, #FFC0CB)',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '20px',
  },
  bannerText: {
    margin: 0,
    fontSize: '20px',
    fontWeight: 'bold',
    color:'#9e1663'
  },
  bodyContainer: {
    display: 'flex',
    flex: 1,
    height: 'calc(100vh - 80px)',
    overflow: 'hidden',
  },
sidebar: {
//  backgroundColor: '#e3eff3',
background: 'linear-gradient(to right, #FFFFE3, #FCF0F0)',
  color: '#021f29',
  height: '100%',
  transition: 'width 0.3s ease',
  borderRight: '1px solid #ccc',
  zIndex: 1000,
  position: 'absolute',  // <--- change this
  left: 0,
  top: 0,
   borderRadius: '8px',
},
  navList: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
  },
  navItem: {
    position: 'relative',
  },
  navLink: {
    padding: '10px 15px',
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    color: '#021f29',
    fontSize: '14px',
    whiteSpace: 'nowrap',
  },
  subMenu: {
    listStyle: 'none',
    paddingLeft: '30px',
    marginTop: '5px',
  },
  subNavLink: {
    padding: '8px 15px',
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    color: '#13859C',
    fontSize: '13px',
    whiteSpace: 'nowrap',
    // borderRadius: '80px',
  },
  icon: {
    marginRight: '10px',
    minWidth: '20px',
    minHeight: '20px',
    fontSize: '20px',
  },
  mainContent: {
    flex: 1,
    overflowY: 'auto',
    height: '100%',
    maxHeight: 'calc(100vh - 80px)',
    //backgroundColor: '#f8f8f8',
    background: 'linear-gradient(to right, #FFFFE3, #FCF0F0)',
    padding: '15px',
  },
};

export default SideNavApp1;
